<script setup lang="ts">
import { darkModeLogo, lightModeLogo } from '@/assets/assetsUtils'
import { getCurrentThemeMode, setCurrentThemeMode } from '@/utils/viewsUtils'
import {
    type ThemeModes,
    type ThemeProviderType,
    EProviders
} from '@rfc/rfc-components-library/types'
import { computed, provide } from 'vue'

const theme = computed(() => getCurrentThemeMode.value)

const setTheme = (value?: ThemeModes) => setCurrentThemeMode(value)

provide<ThemeProviderType>(EProviders.THEME, { theme, setTheme, darkModeLogo, lightModeLogo })
</script>

<template>
    <slot />
</template>
